import {
	RoutesConfig
} from './routes.config';

export enum MappingEventRedirection {
	// Redirection accueil
	redirectionAccueil = RoutesConfig.routeNames.accueil,

	// Evènements d'erreur
	redirection404 = RoutesConfig.routeNames.error404,
	redirection500 = RoutesConfig.routeNames.error500,
	redirectionSessionExpiree = RoutesConfig.routeNames.errorSessionExpiree,
	redirectionVosServices = RoutesConfig.routeNames.vosServices,
	redirectionInactivite = RoutesConfig.routeNames.errorInactivite,
	redirectionForteAffluence = RoutesConfig.routeNames.errorForteAffluence

}

export enum MappingEventRedirectionExterieur {

}
